/* Poorly Pet offers: one source of truth for the offer badges shown on product cards.
   These are the offers in the site's "Offers" menu ("This month's offers"):
     Two supplements, 10% off
     Three supplements, 15% off
     Free wheelchair fitting
     Care kits, up to 15% off
   PPOffers.forProduct(p) returns the offers that apply to a product from products.js, most useful first.
   PPOffers.badge(p) returns the one short label for the card's top-left .tab badge (or null).
   PPOffers.lines(p) returns short lines to show under the price on the .pk card.
   On Shopify these would come from the automatic discounts / a metafield; the rules below mirror the menu. */
(function () {
  function isSupplement(p) {
    if (window.PPSITE && window.PPSITE.isSupplement) return window.PPSITE.isSupplement(p);
    var t = (p.productType || '').toLowerCase();
    return t === 'supplement' || t.indexOf('supplements') === 0 || t === 'digestive support' || t === 'calming aid';
  }
  function isWheelchair(p) { return (p.productType || '') === 'Wheelchair' || /wheelchair/i.test(p.title || ''); }
  function isKit(p) { return (p.productType || '') === 'Condition Bundle' || /\b(bundle|care kit)\b/i.test(p.title || ''); }

  var ALL = [
    { id: 'two-supps', name: 'Two supplements, 10% off', short: '2 for 10% off', test: isSupplement,
      line: function () { return '2 for 10% off, 3 for 15% off'; } },
    { id: 'three-supps', name: 'Three supplements, 15% off', short: '3 for 15% off', test: isSupplement, line: null },
  ];

  /* the supplements offer is a discount code: name it wherever the offer is named in full */
  var CODES = window.PPSITE && window.PPSITE.offers && window.PPSITE.offers.supplementCodes;
  if (CODES) { ALL[0].name += ' with code ' + CODES.two; ALL[1].name += ' with code ' + CODES.three; }
  window.PPOffers = {
    all: ALL.map(function (o) { return { id: o.id, name: o.name, short: o.short }; }),
    forProduct: function (p) { return ALL.filter(function (o) { return o.test(p); }); },
    badge: function (p) { var o = ALL.filter(function (x) { return x.test(p); })[0]; return o ? o.short : null; },
    lines: function (p) {
      return ALL.filter(function (o) { return o.test(p) && o.line; }).map(function (o) { return o.line(p); });
    },
    test: { isSupplement: isSupplement, isWheelchair: isWheelchair, isKit: isKit }
  };
})();
